// extracted by mini-css-extract-plugin
export default {"imgWrapper":"user_profile_img_imgWrapper__wgQzz","img":"user_profile_img_img__UEM2-"};